import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SpendingsHeaderProgressBar from './SpendingsHeaderProgressBar';
import NumberUtils from '../../utils/NumberUtils';

class SpendingsHeaderProgress extends PureComponent {
  static propTypes = {
    content: PropTypes.object,
    leftValue: PropTypes.number,
    rightValue: PropTypes.number,
    labelLeft: PropTypes.string,
    labelRight: PropTypes.string,
    isNoBudget: PropTypes.bool,
    spendingProgressText: PropTypes.string,
  };
  render() {
    const { content, isNoBudget, rightValue, leftValue } = this.props;
    const leftItemValue = NumberUtils.appendCurrency('{}', leftValue);
    const rightItemValue = NumberUtils.appendCurrency('{}', rightValue);

    return (
      <div className="spendings-progress">
        <div className="row">
          <div className="col-xs-3">
            <h6>{this.props.labelLeft}</h6>
            <h2>{leftItemValue}</h2>
          </div>
          <div className="col-xs-6 text-center">
            {isNoBudget ? (
              <SpendingsHeaderProgressBar
                spendingProgressText={this.props.spendingProgressText}
                content={content}
                leftValue={leftValue}
                rightValue={rightValue}
              />
            ) : (
              <div className="spendings-progress-message">
                <h4>{content.spendingHeaderNoBudgetTitle}</h4>
                <p>{content.spendingHeaderNoBudgetMessage}</p>
              </div>
            )}
          </div>
          <div className="col-xs-3">
            <h6>{this.props.labelRight}</h6>
            <h2>{rightItemValue}</h2>
          </div>
        </div>
      </div>
    );
  }
}

export default SpendingsHeaderProgress;
